import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  getSideList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/industry/getOneList");
  },
};
